import * as React from "react";
import dayjs, { Dayjs } from "dayjs";
// import moment from 'moment';
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import moment from "moment";
import { useState } from "react";
import { useEffect } from "react";
import { date } from "yup";

export default function AdminDate({ parentCallback }) {
  // const [transferValue, setTransferValue] = useState("");

  //   const [value, setValue] = React.useState(substractYears(21));
  const [value, setValue] = React.useState(null);
  const [startDate, setStartDate] = useState("");
//  console.log("value-", startDate);

  React.useEffect(() => {
    if (value != null) {
      var date = value;
      //   var now_utc = Date.UTC(
      //     date.getUTCFullYear(),
      //     date.getUTCMonth(),
      //     date.getUTCDate(),
      //     date.getUTCHours(),
      //     date.getUTCMinutes(),
      //     date.getUTCSeconds()
      //   );

      // console.log("njh", startDate, date);

      // setTransferValue(date.toISOString());
      parentCallback(date?.toISOString());
    }
  }, [value]);

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    // const currentYear =2024

    // console.log("x--", currentYear);
    if (currentYear % 4 == 0) {
      //   setStartDate(moment(value.add(10, "days")));
      setStartDate(moment(new Date()?.toISOString()).add(366, "days"));
      setValue(moment(new Date()?.toISOString()).add(366, "days"));
    } else {
      setStartDate(moment(new Date()?.toISOString()).add(365, "days"));
      setValue(moment(new Date()?.toISOString()).add(365, "days"));
    }
  }, []);
  // scheduledDatetime: moment(value?.$d)?.format(
  //   "YYYY-MM-DD HH:mm:ss"
  // ),

  const onKeyDown = (e) => {
    e.preventDefault();
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Stack spacing={3}>
        <DesktopDatePicker
          disablePast
          label="Valid Upto"
          value={value}
          minDate={startDate}
          //   minDate={substractYears(80)}
          //   maxDate={substractYears(21)}

          onChange={(newValue) => {
            setValue(newValue.$d);
          }}
          renderInput={(params) => (
            <TextField
              onKeyDown={onKeyDown}
              {...params}
              helperText={"(Date time format mm/dd/yyyy"}
            />
          )}
        />
      </Stack>
    </LocalizationProvider>
  );
}
